<template>
  <div class="vm-block-feed" ref="block_feed" :class="[is_mark_feed ? 'mark-feed':'', has_load && post_list.length == 0 ? 'no-data': '']">
    <auth-door class="mt16" v-if="!is_my_rec_feed && !is_public_feed && is_verified == 0 && !is_mark_feed" :is_show_btn="is_self"/>
    <template v-if="session_user || is_white_show">
        <div v-if="album_id" class="flex-box flex-direction-row-reverse p16 rank-box black-8">
            <div class="flex-box flex-align-items-center gl-hover-text relative">
                <div @click.self="open_sort" v-click-outside="close_sort">
                  <i class="afd afd-zhengdaoxu mr8"></i>
                  {{rank_text}}
                </div>
                <div v-if="is_show_sort" class="rank-menu pl16 pr16 pt8 pb8">
                  <div class="rank-item flex-box flex-justify-content-space-between pt8 pb8 black-8" @click="order('rank asc')">
                    {{$t('c.BlockFeed.text1')}}<btn class="look1 ml32 pl8 pr8" v-if="is_self && order_by != 'rank asc'" @click.native.stop="set_order_by('rank asc')">{{$t('c.BlockFeed.text5')}}</btn>
                  </div>
                  <div class="rank-item flex-box flex-justify-content-space-between pt8 pb8 black-8" @click="order('rank desc')">
                    {{$t('c.BlockFeed.text2')}} <btn class="look1 ml32 pl8 pr8" v-if="is_self && order_by != 'rank desc'" @click.native.stop="set_order_by('rank desc')">{{$t('c.BlockFeed.text5')}}</btn>
                  </div>
                  <div class="rank-item flex-box flex-justify-content-space-between pt8 pb8 black-8" @click="order('publish_sn asc')">
                    {{$t('c.BlockFeed.text3')}} <btn class="look1 ml32 pl8 pr8" v-if="is_self && order_by != 'publish_sn asc'" @click.native.stop="set_order_by('publish_sn asc')">{{$t('c.BlockFeed.text5')}}</btn>
                  </div>
                  <div class="rank-item flex-box flex-justify-content-space-between pt8 pb8 black-8" @click="order('publish_sn desc')">
                    {{$t('c.BlockFeed.text4')}} <btn class="look1 ml32 pl8 pr8" v-if="is_self && order_by != 'publish_sn desc'" @click.native.stop="set_order_by('publish_sn desc')">{{$t('c.BlockFeed.text5')}}</btn>
                  </div>
                </div>
            </div>
            </div>
            <slot name="tit"></slot>
            <!--<h2 class="fsl24 tit">TA的动态</h2>-->
            <!--<div class="mt24 black-5" v-if="is_self && is_creator && enable_scroll_load && post_list.length == 0">-->

            <!--可在顶部点击发布-->
            <!--</div>-->
            <div class="tab-box-wrapper mt16" v-if="!is_search_slug_feed && bread_tab && bread_tab.length > 0">
                <div ref="tabs" v-if="!is_applying_apple" class="tab-box" :class="{on: is_overmuch}">
                    <div ref="inner">
                        <template v-for="(item, i) in bread_tab" >
                            <btn v-if="item.key != 'plan_id' || item.count > 0"
                              :key="i"
                              :class="[item.key == tab_key && item.value == tab_value ? 'look3' : 'look12']"
                              @click.native="tab(item.key, item.value)"
                              class="mr8 circle mb10 pt10 pb10 pr16 pl16 fs12">
                              <span :class="[item.key == tab_key && item.value == tab_value ? 'fwb' : '']">{{item.name}}</span>
                              <span v-if="item.count > 0" class="ml8 count" :class="[item.key == tab_key && item.value == tab_value ? '' : 'black-3']">{{item.count}}{{$t('c.BlockFeed.text6')}}</span>
                          </btn>
                        </template>
                    </div>
                </div>
                <div v-if="is_overmuch" @click="show_tab" class="flex-box flex-center black-3 fs12 pt16 gl-hover-text">
                    <i class="afd afd-arrow-down mr8 fs12"></i>
                    <span>{{$t('c.BlockFeed.text7')}}</span>
                </div>
            </div>
            <div v-if="is_show_no_data_tip && enable_scroll_load && post_list.length == 0 && is_verified == 1" class="mt48 black-5 flex-box flex-center pb32">
              {{group_id ? $t('c.BlockFeed.text8') : $t('c.BlockFeed.text9')}}
            </div>
            <div v-if="!is_public_feed && is_my_rec_feed && enable_scroll_load && post_list.length == 0" @click="tab_public_feed" class="mt48 black-3 text-center fs14 pb32">
              <div>{{$t('c.BlockFeed.text10')}}</div>
              <div class="mt8">{{$t('c.BlockFeed.text11')}} <span class="pointer purple">{{$t('c.BlockFeed.text12')}}</span></div>
            </div>
            <feed
              v-for="(post, i) in post_list"
              :class="{'item-1': i == 0 && !is_public_feed && !is_my_rec_feed}"
              class="mt-16-0 mq"
              :key="post.post_id"
              :user="is_public_feed || is_my_rec_feed || is_mark_feed || group_id ? post.user : this_user"
              :album_id="album_id"
              :group_id="group_id"
              :group="group"
              :post="post"
              :is_href_blank="(GL.ENV.is_afd_client || album_id) ? false : true"
              @refresh="refresh"
              :is_visit_post_page="true"
            ></feed>
            <div class="relative mt24" v-if="is_loading">
            <div class="loading-box">
                <img
                style="width: 50px;margin-left: -25px;"
                src="/static/img/asset/loding.png"
                class="loading self-center-loading"
                />
            </div>
        </div>
    </template>
    <div v-else class="mq pl-0-16 pr-0-16 mt16">
      <div class="no-login-feed p24 flex-box flex-direction-column">
        <div class="flex-box flex-center black-8 fs14">{{$t('c.BlockFeed.text13')}}</div>
        <router-link to="/reg" class="w100 flex-box flex-center">
            <btn class="mt16 fs14">{{$t('c.BlockFeed.text14')}}</btn>
        </router-link>
        <router-link to="/login" class="w100 flex-box flex-center">
            <div class="mt16 purple fs14">{{$t('c.BlockFeed.text15')}}</div>
        </router-link>
      </div>
    </div>
    <div v-if="is_mark_feed && has_load && post_list.length == 0" class="black-3 mt-32-16 mq">
        {{$t('c.BlockFeed.text16')}}
    </div>
  </div>
</template>

<script>
import {
  GET_POST_LIST,
  GET_REC_LIST,
  GET_CREATOR_GET_ALBUM_POST,
  POST_CREATOR_UPDATE_ALBUM_POST_ORDER_BY,
  GET_USER_GET_GROUP_FEED,
  GET_MY_MARKED_POST,
  GET_MY_REC_LIST,
  GET_POST_GET_DETAIL,
  // POST_API_CREATOR_SEARCH,
} from "@/api/config";
import { mapState } from "vuex";
export default {
  name: "block-feed",
  props: {
    is_white_show: {
      default() {
        return false;
      },
    },
    is_public_feed: {
      default() {
        return false;
      },
    },
    is_my_rec_feed: {
      default() {
        return false;
      },
    },
    is_mark_feed: {
      default() {
        return false;
      },
    },
    is_search_slug_feed: {
      default() {
        return false;
      },
    },
    album_id: {
      default() {
        return "";
      },
    },
    is_enable_load: {
      default() {
        return true;
      },
    },
    is_plan_call_filter: {
      default() {
        return false;
      },
    },
    is_show_no_data_tip: {
      default() {
        return true;
      },
    },
    filter_type: {
      default() {
        return "old";
      },
    },
    group_id: {
      default() {
        return "";
      },
    },
    group: {
      default() {
        return {};
      },
    },
    album: {
      default() {
        return {};
      },
    },
    filter: {
      default() {
        return "all";
      },
    },
    post_list_ext: {
      default() {
        return [];
      },
    },
  },
  data() {
    let order_by = this.album.order_by || 'rank asc';
    let rankField = order_by.split(' ')[0];
    let rankOrder = order_by.split(' ')[1];
    let feed_filter_key = this.$route.query.feed_filter_key; //参照：bread_tab：  all || is_public || plan_id
    let feed_filter_value = this.$route.query.feed_filter_value;
    return {
      post_list: this.post_list_ext.length > 0 ? this.post_list_ext : [],
      enable_scroll_load: false,
      is_loading: false,
      is_refreshing: false,
      has_more: 1,
      is_show_sort:false,
      // query_tab_key: this.$route.query.query_tab_key || '',
      bread_tab:[],
      tab_key: feed_filter_key || 'all',
      tab_value: feed_filter_value || '1',
      // tab_key: 'all',
      // tab_value: '1',
      is_overmuch:false,
    //   limit_height:this.browser_size == 'small' ? 126 : 126, //以为会不一样
      rankField,
      rankOrder,
      order_by,
      mark_page:1,
      has_load: false,
      search_page: 1,
      search_has_more: 1,
    };
  },
  watch: {
    filter_type(v) {
      this.refresh("replace");
    },
    filter(v) {
      this.refresh("replace");
    },
    is_my_rec_feed(){
      this.refresh("replace");
    },
    post_list_ext(v){
      this.post_list = v
    },
    // tab_value(){
    //   this.refresh("replace");
    // }
  },
  computed: {
    ...mapState("app", ["session_user", "user_status", "is_scroll_load","browser_size",'is_applying_apple']),
    ...mapState("user", ["this_user"]),
    rank_text() {
      return {
        'rank asc': this.$t('c.BlockFeed.text1'),
        'rank desc': this.$t('c.BlockFeed.text2'),
        'publish_sn asc': this.$t('c.BlockFeed.text3'),
        'publish_sn desc':this.$t('c.BlockFeed.text4'),
      }[`${this.rankField} ${this.rankOrder}`];
    },
    newest_publish_sn() {
      if (this.is_refreshing) {
        return "";
      }
      return this.post_list.length > 0 ? this.post_list[0].publish_sn : "";
    },
    oldest_publish_sn() {
      if (this.is_refreshing) {
        return "";
      }
      return this.post_list.length > 0
        ? this.post_list[this.post_list.length - 1].publish_sn
        : "";
    },
    last_rank() {
      return this.post_list.length > 0
        ? this.post_list[this.post_list.length - 1].rank
        : "";
    },
    is_verified(){
      if (
        this.this_user &&
        this.this_user.is_verified ||
        this.$route.name == 'groupGroupId'
      ) {
        return 1;
      }
      return 0;
    },
    is_creator() {
      if (
        this.this_user &&
        this.this_user.creator &&
        this.this_user.creator.status
      ) {
        return true;
      }
      return false;
    },
    is_self() {
      if (
        this.this_user &&
        this.session_user &&
        this.this_user.user_id == this.session_user.user_id
      ) {
        return true;
      }
      return false;
    },
    is_v() {
      if (
        this.session_user &&
        this.session_user.is_verified == 1 && this.session_user.verified_type == 1
      ) {
        return true;
      }
      return false;
    },
    api() {
      // if (this.is_search_slug_feed) {
      //   return POST_API_CREATOR_SEARCH;
      // }
      if (this.is_my_rec_feed) {
        return GET_MY_REC_LIST;
      }
      if(this.is_mark_feed){
        return GET_MY_MARKED_POST;
      }
      if (this.album_id) {
        return GET_CREATOR_GET_ALBUM_POST;
      }
      if (this.is_public_feed) {
        return GET_REC_LIST;
      }
      if (this.group_id) {
        return GET_USER_GET_GROUP_FEED;
      }
      return GET_POST_LIST;
    },
  },
  async mounted() {
    this.$bus.$on("FEED_REMOVE_SUCCESS", (arg) => {
      this.modify_post(arg.post_id);
    });
    this.$bus.$on("FEED_PUBLISH_SUCCESS", (arg) => {
      this.modify_post(arg.post_id, arg.post);
    });
    this.$bus.$on("SCROLL_LOAD_MORE_FEED", () => {
      this.load_more();
    });
    this.$bus.$on("FEED_REFRESH", (arg) => {
      this.refresh("replace");
    });
    this.$bus.$on('VISIBILITYCHANGE', (data) => {
      if(data.is_show){
        this.update_post()
      }
    });
    if(this.is_plan_call_filter){
      this.$bus.$on('FEED_UNLOCK_TAP',(data) => {
        // console.log(this.$refs['block_feed'].scrollIntoView())
        this.$refs['block_feed'].scrollIntoView({ behavior: "smooth" })
        this.tab(data.key,data.value)
      })
    }
    if(this.is_search_slug_feed){
      return false;
    }

    if (
      this.this_user ||
      this.is_public_feed ||
      this.is_my_rec_feed ||
      this.is_mark_feed ||
      this.album_id ||
      this.group_id
    ) {
      await this.get_post_list();
      this.enable_scroll_load = true;
      if(this.$route.query.pos_feed == 1){ //参数控制滚动
        this.$nextTick(() => {
          setTimeout(() => { //有的接口慢
            this.$refs['block_feed'].scrollIntoView({ behavior: "smooth" })
          },100)
        })
      }
    }
  },
  beforeDestroy() {
    this.$bus.$off("FEED_REMOVE_SUCCESS");
    this.$bus.$off("FEED_PUBLISH_SUCCESS");
    this.$bus.$off("SCROLL_LOAD_MORE_FEED");
    this.$bus.$off("FEED_REFRESH");
    this.$bus.$off("VISIBILITYCHANGE");
  },
  methods: {
    tab_public_feed(){
        this.$emit('tab_public_feed')
    },
    open_sort(){
      this.is_show_sort = !this.is_show_sort
    },
    close_sort(){
      this.is_show_sort = false
    },
    async set_order_by(val){
      this.order_by = val
      this.order(val)
      if (this.$http.is_run(POST_CREATOR_UPDATE_ALBUM_POST_ORDER_BY)) {
          return false;
      }
      let data = await this.$http.$axios(POST_CREATOR_UPDATE_ALBUM_POST_ORDER_BY,{
        album_id:this.album_id,
        order_by:this.order_by,
      });

      this.$notify({
          title: data.em,
          group: data.ec != 200 ? "error" : 'success',
      });
      this.$emit('set_order_by')
      return false;
    },
    order(val){
      this.rankField = val.split(' ')[0]
      this.rankOrder = val.split(' ')[1]
      this.refresh("replace");
      this.close_sort()
    },
    // rank() {
    //   this.rankOrder = this.rankOrder == "desc" ? "" : "desc";
    //   this.refresh("replace");
    // },
    modify_post(post_id, post) {
      let index = "";
      this.post_list.forEach((v, k) => {
        if (v.post_id == post_id) {
          index = k;
        }
      });
      if (post) {
        this.post_list.splice(index, 1, post);
      } else {
        this.post_list.splice(index, 1);
      }
    },
    tab(key, value){
        this.tab_key = key;
        this.tab_value = value;
        this.refresh("replace");
    },
    get_post_data(type) {
      if (this.is_mark_feed) {
        return {
            page:this.mark_page
        };
      }
      let data = {
        type: type,
        publish_sn: this.oldest_publish_sn,
        //   type == "old" ? this.oldest_publish_sn : this.newest_publish_sn
      };
      data[this.tab_key] = this.tab_value;
      if (this.is_public_feed || this.is_my_rec_feed) {
        return data;
      }
      if (this.this_user) {
        data.user_id = this.this_user.user_id;
      }
      if (this.album_id) {
        data = {
          album_id: this.album_id,
          lastRank: this.last_rank,
          rankOrder: this.rankOrder,
          rankField:this.rankField,
        };
      }
      if (this.group_id && this.filter) {
        data = {
          group_id: this.group_id,
          filter: this.filter,
          publish_sn: this.oldest_publish_sn,
        };
      }
      // if (this.is_search_slug_feed) {
      //   data = {
      //     user_id: this.this_user.user_id, 
      //     keyword: this.keyword, 
      //     type:'feed', 
      //     page: 1
      //   }
      // }
      return data;
    },
    async update_post(){
      let update_feed_id = localStorage.getItem("FEED_PUBLISH_SUCCESS_ID")
      if(!update_feed_id){
        return false;
      }
      if (this.$http.is_run(GET_POST_GET_DETAIL)) {
        return false;
      }
      let data = await this.$http.$axios(GET_POST_GET_DETAIL, {
        post_id: update_feed_id,
      });

      if (data.ec != 200) {
        this.$notify({
            title: data.em,
            group: "error",
        });
        return false;
      }
      this.post_list.forEach((v, k) => {
        if(v.post_id == update_feed_id){
          this.post_list.splice(k, 1, data.data.post)
          localStorage.removeItem("FEED_PUBLISH_SUCCESS_ID")
        }
      })
    },
    async get_post_list(type) {
      if (!this.is_enable_load) {
        return false;
      }

      if (!this.is_v && this.is_verified == 0 && !this.is_public_feed && !this.is_my_rec_feed && !this.is_self && !this.is_mark_feed) {
        return false;
      }

      if (this.$http.is_run(this.api)) {
        return false;
      }
      // type = type || this.filter_type;
      this.is_loading = true;
      let post_data = this.get_post_data(this.filter_type);
      if(type == 'replace' && post_data.hasOwnProperty("lastRank")){ //for UI 不滚动
        post_data.lastRank = 0;
      }
      let data = await this.$http.$axios(
        this.api,
        post_data
      );
      this.has_load = true;
      this.is_loading = false;
      if(this.$route.query.feed_filter_value && data.data.list.length == 0){ //跳转过来后，如果plan_id 是空数据，再加载一下全部
        this.tab('all','1');
        return false;
      }
      if (data.ec != 200) {
        this.$notify({
          title: data.em,
          group: "error",
        });
        this.has_more = 0;
        return false;
      }
      this.bread_tab =  data.data.bread_tab
      this.has_more = data.data.has_more;

      if (data.data.has_more == 0) {
        this.$bus.$emit("FEED_HAS_MORE_0");
      }
      if (type == "replace") {
        this.post_list = []
        this.$nextTick(() => {
          this.post_list = data.data.list;
        })
        return false;
      }
      this.post_list = this.post_list.concat(data.data.list);
      this.compute_tabs_height()
    },
    compute_tabs_height(){
        if(this.bread_tab && this.bread_tab.length > 0){
            this.$nextTick(() => {
                this.is_overmuch = this.$refs.inner && this.$refs.inner.offsetHeight > 126
            })
        }
    },
    show_tab(){
        this.is_overmuch = false;
    },
    async refresh(type = "") {
      this.is_enable_load = true;
      this.has_more = 1;
      this.is_refreshing = true;
      if (type == "") {
        this.post_list = [];
      }
      await this.get_post_list(type);
      this.is_refreshing = false;
    },
    async load_more() {
      if (this.enable_scroll_load && this.has_more && !this.mixin_scroll_busy) {
        this.mark_page++
        this.mixin_scroll_busy = true;
        await this.get_post_list();
        this.mixin_scroll_busy = false;
      }
    },
  },
};
</script>

<style lang="stylus" scoped>
.vm-block-feed {
  padding-top:0.5px;
  &.mark-feed{
    margin-top:24px;
    .vm-feed.item-1{
      border-top: 1px solid rgba(0,0,0,.1);
    }
  }
  &.search-feed{
    margin-top:0px;
    .vm-feed.item-1{
      border-top: 1px solid rgba(0,0,0,.1);
      padding-top: 16px !important;
    }
  }
  .no-login-feed{
      background: rgba(0, 0, 0, 0.03);
      border-radius: 2px;
      .vm-btn{
          width:120px;
      }
  }
  .rank-menu{
    position absolute;
    border:1px solid $black-1;
    right:0;
    top:25px;
    border-radius:4px;
    background: $white;
    box-shadow :$layer-box-shadow;
    white-space: nowrap;
    z-index 1;
  }
  .tab-box{
      &.on{
          max-height:126px;
          overflow :hidden;
      }
  }
  .vm-btn {
      &.look12{
          &:hover {
            color: $purple;
            background: $purple-1;
            .count{
                color: $purple !important;
            }
        }
      }
      &.look3{
          &:hover {
            background: $purple-1;
        }
      }
  }
  .tab-box-wrapper{
    background: $white;
    border-radius: 4px 4px 0 0;
    border: 1px solid $black-1;
    border-bottom:0;
    padding: 16px 16px 0 16px;
  }
  .vm-feed{
      &.item-1{
          border-top:0;
          margin-top:0 !important;
          padding-top:8px !important;
      }
  }
  @media (max-width: $width-mobile) {
    background: $white;
    &.mark-feed{
      margin-top:16px;
      .vm-feed.item-1{
        border-top: 0;
      }
      &.on-data{
        margin-top:0px;
      }
      .vm-feed{
        padding: px2rem(24) 0;
      }
    }
    &.search-feed{
      .vm-feed.item-1{
        border-top: 0;
        padding-top:0px !important;
      }
    }
    .vm-feed{
      border-width: 0 0 1px 0;
      border-radius: 0px;
    }

    .tab-box-wrapper{
        background: none;
        border-radius: 0px;
        border: none;
        padding: 0 16px 0 16px;
    }

    .rank-box {
      background: $white;
    }
  }
}
</style>
